"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditType = exports.PlanIds = exports.PlanTypes = void 0;
var PlanTypes;
(function (PlanTypes) {
    PlanTypes["PAYG"] = "PAY_AS_YOU_GO_PLAN";
    PlanTypes["BASIC"] = "BASIC_PLAN";
    PlanTypes["PREMIUM"] = "PREMIUM_PLAN";
    PlanTypes["BUSINESS"] = "BUSINESS_PLAN";
    PlanTypes["MANSION"] = "MANSION_ENTERPRISE_PLAN";
    PlanTypes["BITPING_PAID"] = "BITPING_PAID_ENTERPRISE_PLAN";
    PlanTypes["INFOTRACK"] = "INFOTRACK_ENTERPRISE_PLAN";
})(PlanTypes = exports.PlanTypes || (exports.PlanTypes = {}));
var PlanIds;
(function (PlanIds) {
    PlanIds[PlanIds["PAYG"] = 0] = "PAYG";
    PlanIds[PlanIds["BASIC"] = 1] = "BASIC";
    PlanIds[PlanIds["PREMIUM"] = 2] = "PREMIUM";
    PlanIds[PlanIds["BUSINESS"] = 3] = "BUSINESS";
    PlanIds[PlanIds["MANSION"] = 4] = "MANSION";
    PlanIds[PlanIds["BITPING_PAID"] = 5] = "BITPING_PAID";
    PlanIds[PlanIds["INFOTRACK"] = 7] = "INFOTRACK";
})(PlanIds = exports.PlanIds || (exports.PlanIds = {}));
var CreditType;
(function (CreditType) {
    CreditType["Standard"] = "standard";
    CreditType["Complementary"] = "complementary";
    CreditType["Trial"] = "trial";
})(CreditType = exports.CreditType || (exports.CreditType = {}));
